import React from 'react';
import { colors, CircularProgress, Grid } from '@material-ui/core';

import Step from 'components/stepper/Step';
import NotFoundWarning from 'components/recipes/NotFoundWarning';
import FailedWarning from './FailedWarning';

const RecipeLoading = ({
  exitPage,
  isLoading,
  notFound,
  hasFailed,
  loadRecipe,
}) => {
  return (
    <Step
      onBackButtonClick={exitPage}
      renderBody={() => {
        if (notFound) return <NotFoundWarning></NotFoundWarning>;

        if (isLoading)
          return (
            <Grid container justify="center">
              <CircularProgress
                style={{ color: colors.red[400] }}
              ></CircularProgress>
            </Grid>
          );

        if (hasFailed)
          return <FailedWarning loadRecipe={loadRecipe}></FailedWarning>;
      }}
    ></Step>
  );
};

export default RecipeLoading;
